'use client';

import {
  useGetMarketField,
  useGetPlatformConfig,
  useGetProposalField,
  useMarketConfig,
  useMarketConfigCatalog,
} from '@morfi/backend-sdk-v2/client';

export interface OutcomesLimits {
  minOutcomes: number | null;
  maxOutcomes: number | null;
  isLoading: boolean;
  isError: boolean;
}

/** Creation uses the current address; existing markets never use that default. */
export function useOutcomesLimits(marketPubkey?: string): OutcomesLimits {
  const current = useGetPlatformConfig(
    { kind: 'market', fields: ['marketConfig'] },
    { enabled: marketPubkey === undefined },
  );
  const proposalAddress = useGetProposalField({ pubkey: marketPubkey ?? '' }, 'marketConfig');
  const marketAddress = useGetMarketField({ pubkey: marketPubkey ?? '' }, 'marketConfig');
  const catalog = useMarketConfigCatalog();
  const data = useMarketConfig(
    marketPubkey === undefined
      ? current.data?.marketConfig
      : (proposalAddress ?? marketAddress ?? null),
  );
  const isLoading =
    catalog.status === 'loading' || (marketPubkey === undefined && current.isPending);
  return {
    minOutcomes: data?.minOutcomes ?? null,
    maxOutcomes: data?.maxOutcomes ?? null,
    isLoading,
    isError: !isLoading && data === undefined,
  };
}
